export const faqList = [
  {
    q: "「黑料网爆」主要更新哪些内容？",
    a: "我们主要跟进综艺现场、影视动态、音乐现场、品牌代言与网络热议这几类话题，把全网正在讨论的热点整理到同一处。所有内容以「全网讨论」的视角呈现，方便你快速了解来龙去脉。",
  },
  {
    q: "首页的「实时爆料流」「晚间热搜」「刚刚发生」有什么区别？",
    a: "实时爆料流按时间顺序滚动更新，适合随时刷新；晚间热搜按热度排出榜单，适合晚上一次性浏览当天重点；「刚刚发生」只保留最近几小时的最新动态，适合不想错过新瓜的蹲点用户。",
  },
  {
    q: "为什么有些话题没有给出明确结论？",
    a: "很多热点在短时间内仍在持续发酵，信息也会不断补充。我们更倾向于把已经出现的讨论、反馈和时间线整理清楚，而不是过早下判断，你可以关注后续更新。",
  },
  {
    q: "可以在手机上浏览吗？",
    a: "可以。网站针对手机、平板和电脑都做了适配，导航在手机上会收成一个菜单按钮，点击即可展开。任何尺寸的屏幕都能正常阅读。",
  },
  {
    q: "如何第一时间看到最新的热点？",
    a: "建议收藏首页，晚间时段（20:00 之后）刷新频率最高。你也可以先浏览分类专题页，关注自己最常看的栏目，这样能更快定位到感兴趣的内容。",
  },
  {
    q: "发现内容有误或想补充消息，怎么联系你们？",
    a: "可以通过页脚或关于我们页面留下的邮箱联系我们，说明具体的话题与问题，我们会尽快核对并更新。欢迎提供更准确的时间线信息。",
  },
];